module.exports = __webpack_public_path__ + "img/logo.19b88d8a.png";